import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import HeaderComp from "../components/HeaderAdmin"
import { Col, Row, Card, CardBody, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, ListGroup, ListGroupItem } from 'reactstrap';
import TablaAreas from "../components/tablesAdmin/TableAreas";
import TablaClientes from "../components/tablesAdmin/TableCliente";
import TablaSuspension from "../components/tablesAdmin/TableSuspension";
import TablaModulos from "../components/tablesAdmin/TableModulos";
import TablaServiciosPadre from "../components/tablesAdmin/TableServiciosPadre";
import TablaServiciosHijo from "../components/tablesAdmin/TableServiciosHijo";
import TablaPrioridad from "../components/tablesAdmin/TablePrioridad";
import TablaClienteRol from "../components/tablesAdmin/TableClienteRol";
import TablaClientePrograma from "../components/tablesAdmin/TableClientePrograma";
import TablaServiciosArea from "../components/tablesAdmin/TableServiciosAreas";
import TablaUsuarioServicios from "../components/tablesAdmin/TableUsuariosServicios";
import TablaClienteServicios from "../components/tablesAdmin/TableClienteServicio";
import TablaServiciosPrograma from "../components/tablesAdmin/TableServiciosPrograma";

const mapStateToProps = state => {
    return { agente: state.agente };
};

class HomeAdmin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            modificandoActual: "Areas",
        };
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.cambiarGestion = this.cambiarGestion.bind(this);
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    componentDidMount() {
        document.title = "DigiturnoKL - Administrador"
    }

    async cambiarGestion(event) {
        await this.setState({
            modificandoActual: event.target.id
        })
        this.toggleNavbar();
    }

    render() {
        if (this.props.agente.nombreAgente === undefined || this.props.agente === undefined || this.props.agente === {}) {
            return <Redirect to={{ pathname: '/Cliente' }} />
        }

        let tablaActual = "";
        switch (this.state.modificandoActual) {
            case ("Areas"):
                tablaActual = <TablaAreas />
                break;
            case ("Módulos"):
                tablaActual = <TablaModulos />
                break;
            case ("Tipos de suspensión"):
                tablaActual = <TablaSuspension />
                break;
            case ("Servicios padre"):
                tablaActual = <TablaServiciosPadre />
                break;
            case ("Servicios hijo"):
                tablaActual = <TablaServiciosHijo />
                break;
            case ("Clientes"):
                tablaActual = <TablaClientes />
                break;
            case ("Prioridad"):
                tablaActual = <TablaPrioridad />
                break;
            case ("Roles de Clientes"):
                tablaActual = <TablaClienteRol />
                break;
            case ("Programas de Clientes"):
                tablaActual = <TablaClientePrograma />
                break;
            case ("Servicios de Area"):
                tablaActual = <TablaServiciosArea />
                break;
            case ("Servicios de Usuarios"):
                tablaActual = <TablaUsuarioServicios />
                break;
            case ("Servicios de Clientes"):
                tablaActual = <TablaClienteServicios />
                break;
            case ("Servicios de Programas"):
                tablaActual = <TablaServiciosPrograma />
                break;
            default:

        }
        return (
            <div className="cuerpo envoltura" id="outer-container">
                <Row>
                    <Col xs={{ size: 12 }}>
                        <HeaderComp></HeaderComp>
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <Card>
                            <CardBody>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col lg={{ size: 12 }}>
                                                <Navbar color="faded" light>
                                                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                                    <NavbarBrand className="mr-auto">Gestionar {this.state.modificandoActual}</NavbarBrand>
                                                    <Collapse isOpen={!this.state.collapsed} navbar>
                                                        <Nav navbar>
                                                            <ListGroup>
                                                                <ListGroupItem id="Areas" onClick={this.cambiarGestion}>
                                                                    Gestionar Areas
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Módulos" onClick={this.cambiarGestion}>
                                                                    Gestionar Módulos
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Tipos de suspensión" onClick={this.cambiarGestion}>
                                                                    Gestionar Tipos de suspensión
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Servicios padre" onClick={this.cambiarGestion}>
                                                                    Gestionar Servicios padre
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Servicios hijo" onClick={this.cambiarGestion}>
                                                                    Gestionar Servicios hijo
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Clientes" onClick={this.cambiarGestion}>
                                                                    Gestionar Clientes
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Prioridad" onClick={this.cambiarGestion}>
                                                                    Gestionar Prioridad de Usuarios
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Roles de Clientes" onClick={this.cambiarGestion}>
                                                                    Gestionar Roles de Clientes
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Programas de Clientes" onClick={this.cambiarGestion}>
                                                                    Gestionar Programas de Clientes
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Servicios de Area" onClick={this.cambiarGestion}>
                                                                    Gestionar Servicios de Áreas
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Servicios de Usuarios" onClick={this.cambiarGestion}>
                                                                    Gestionar Servicios de los Usuarios
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Servicios de Clientes" onClick={this.cambiarGestion}>
                                                                    Gestionar Servicios de los Clientes
                                                                </ListGroupItem>
                                                                <ListGroupItem id="Servicios de Programas" onClick={this.cambiarGestion}>
                                                                    Gestionar Servicios de los Programas
                                                                </ListGroupItem>
                                                            </ListGroup>
                                                        </Nav>
                                                    </Collapse>
                                                </Navbar>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                    <Card>
                                        {tablaActual}
                                    </Card>
                                </Card>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(mapStateToProps)(HomeAdmin);
